import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=7e157a57&scoped=true&"
import script from "./NewsListing.vue?vue&type=script&lang=js&"
export * from "./NewsListing.vue?vue&type=script&lang=js&"
import style0 from "./NewsListing.vue?vue&type=style&index=0&id=7e157a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e157a57",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListing.vue
// module id = 351
// module chunks = 0